import { Link } from "react-router-dom";
import { MapPin, Heart } from "lucide-react";
import { useSettings } from "../lib/settings";

export default function MobileBar() {
  const { settings } = useSettings();
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-cream/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
    >
      <div className="flex items-stretch gap-2 px-4 py-2.5">
        <a
          data-testid="mobile-bar-itinerary"
          href={settings.maps_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-obsidian/15 bg-white px-4 py-3 text-sm font-semibold text-obsidian"
        >
          <MapPin className="h-4 w-4 text-terracotta" />
          Itinéraire
        </a>
        <Link
          data-testid="mobile-bar-visit"
          to="/premiere-visite"
          className="inline-flex flex-[1.4] items-center justify-center gap-2 rounded-full bg-terracotta px-4 py-3 text-sm font-semibold text-white"
        >
          <Heart className="h-4 w-4" />
          Nous rendre visite
        </Link>
      </div>
    </div>
  );
}
